import create from 'zustand';

interface BomVersionState {
   itemBomVersions: Map<string, string>;
   setItemBomVersion: (itemNo: string, bomValidFrom: string | null) => void;
   getItemBomVersion: (itemNo: string) => string | null;
   clearItemBomVersion: (itemNo: string) => void;
   clearAllBomVersions: () => void;
}

export const useBomVersionState = create<BomVersionState>((set, get) => ({
   itemBomVersions: new Map(),

   setItemBomVersion: (itemNo: string, bomValidFrom: string | null) => {
      set((state) => {
         const newMap = new Map(state.itemBomVersions);
         if (bomValidFrom) {
            newMap.set(itemNo, bomValidFrom);
         } else {
            newMap.delete(itemNo);
         }
         return { itemBomVersions: newMap };
      });
   },

   getItemBomVersion: (itemNo: string) => {
      return get().itemBomVersions.get(itemNo) || null;
   },

   clearItemBomVersion: (itemNo: string) => {
      set((state) => {
         const newMap = new Map(state.itemBomVersions);
         newMap.delete(itemNo);
         return { itemBomVersions: newMap };
      });
   },

   clearAllBomVersions: () => {
      set({ itemBomVersions: new Map() });
   },
}));
